module.exports = __webpack_public_path__ + "img/zombie-alts.2e39a45e.gif";